import { useMemo } from 'react';
// TODO(APGA-509): replace this in-module mock with the live-event CHIRP query
// once the endpoint exists. Mirrors the shape of useSimplePlaylists so the
// merge in useLearningContentCardModels stays the same when we cut over.
const MOCK_SUBTYPES = ['WORKSHOP', 'OFFICE_HOURS', 'ORIENTATION'];
const buildMockLiveEvent = id => {
  const eventType = MOCK_SUBTYPES[id % MOCK_SUBTYPES.length];
  return {
    id,
    type: 'LIVE_EVENT',
    eventType,
    name: `Live event ${id}`,
    description: `Mocked live event ${id} description`,
    language: 'EN',
    sessionTime: 'Tue, May 5 \u00B7 11:00 AM \u2013 12:00 PM EST',
    previewThumbnailRectangleUrl: `www.previewrectangleurl.com/live-event/${id}`,
    previewThumbnailSquareUrl: `www.previewsquareurl.com/live-event/${id}`
  };
};
export const useSimpleLiveEvents = ({
  liveEventIds,
  skip
}) => {
  // liveEventIds is built inline via .filter().map() in the caller, so its
  // reference churns every render. Key the memo on the serialized id set so
  // we don't rebuild the mock on every render. Once the CHIRP query replaces
  // the mock, useQuery's deep-eq handles this and the wrapper goes away.
  const liveEventIdsKey = liveEventIds.join(',');
  const simpleLiveEvents = useMemo(() => {
    if (skip || !liveEventIds.length) return null;
    return liveEventIds.reduce((acc, id) => {
      acc[id] = buildMockLiveEvent(id);
      return acc;
    }, {});
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [liveEventIdsKey, skip]);
  return {
    simpleLiveEvents,
    simpleLiveEventsLoading: false,
    simpleLiveEventsError: undefined
  };
};